import { render, staticRenderFns } from "./loginCandidati.vue?vue&type=template&id=4195fdb4&scoped=true&"
import script from "./loginCandidati.vue?vue&type=script&lang=js&"
export * from "./loginCandidati.vue?vue&type=script&lang=js&"
import style0 from "./loginCandidati.vue?vue&type=style&index=0&id=4195fdb4&lang=css&scoped=true&"
import style1 from "./loginCandidati.vue?vue&type=style&index=1&id=4195fdb4&scoped=true&lang=css&"
import style2 from "./loginCandidati.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195fdb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VTextField})
